<template>
  <local-map-with-sidebar-page class="full-height"
                               :filtered-boundaries="filteredBoundaries"
                               :filter-options="filterOptions"
                               :include-search-field="includeSearchField"
                               :organisation-boundaries="organisationBoundaries"
                               :search-strategy="searchStrategy"
                               :show-event-type-filter="showEventTypeFilter"
                               :show-label-filter="showLabelFilter"
                               :show-region-filter="showRegionFilter"
                               :show-type-filter="showTypeFilter" />
</template>

<script>
import GeoipCountryMixin from '@/location-search/geoip-country-mixin'
import LocalMapWithSidebarPage from './local-map-with-sidebar-page'
import { sharedMapPropsMixin } from './shared-map-props'

export default {
  components: { LocalMapWithSidebarPage },

  mixins: [ GeoipCountryMixin, sharedMapPropsMixin ],

  props: {
    eventCreationAllowed: {
      type: Boolean,
      required: false,
      default: undefined
    },
    filterOptions: {
      type: Object,
      required: true
    },
    groupCreationAllowed: {
      type: Boolean,
      required: true
    },
    includeSearchField: {
      type: Boolean,
      required: false,
      default: true
    },
    showEventTypeFilter: {
      type: Boolean,
      required: true
    },
    showLabelFilter: {
      type: Boolean,
      required: true
    },
    showRegionFilter: {
      type: Boolean,
      required: true
    },
    showTypeFilter: {
      type: Boolean,
      required: true
    }
  },

  created() {
    this.$store.commit('setEventCreationAllowed', this.eventCreationAllowed)
    this.$store.commit('setGroupCreationAllowed', this.groupCreationAllowed)
  }
}
</script>

<style lang="scss" scoped>
.full-height {
  height: 100vh;
}
</style>
